<template lang="pug">
  include /mixins
  +b.relative
    ui-loader(v-if='isLoad')
    +b.VALIDATION-OBSERVER(
      ref="validator",
      v-slot="{ valid }",
      tag="form",
    )
      +b.g-row.--space_2xl.--appearance_spaced
        +b.g-cell.g-cols--12.--6-xl
          d-control-input(
            :rules="'required'",
            :input-label='_("Ваше ім‘я ")'
            v-model='form.name'
            id='name',
            name='name',
          )
        +b.g-cell.g-cols--12.--6-xl
          d-control-multiselect(
            :options='subjects'
            :rules="'required'",
            v-model='subject'
            label="caption",
            :input-label='_("Оберіть тему")'
            track-by='id'
            id='subject'
            name='subject'
          )
        +b.g-cell.g-cols--12.--6-xl
          d-control-input(
            :rules="'required|email'",
            :input-label='_("Email")'
            v-model='form.email',
            name='email'
            type='email'
          )
        +b.g-cell.g-cols--12.--6-xl
          phone-input(
            :rules="'required|phone'",
            :input-label='_("Ваш номер телефону")'
            v-model='form.phone',
            name='phone'
          )
        +b.g-cell.g-cols--12
          d-control-textarea.is-textarea(
            :rules="'required'",
            :input-label='_("Коментар")'
            rows='5'
            error-classes='error-label--top'
            v-model='form.message',
            name='message'
          )
        +b.g-cell.g-cols--12
          +b.ds-caption.--size_sm.--medium.--color_black.P {{ _("Нажимая кнопку “Отправить вы соглашаетесь с") }} &nbsp;
            +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm.--medium(
              :href="offer"
              target="_blank"
            ) {{ _("политикой конфиденциальности") }}
            span &nbsp; {{ _("и") }} &nbsp;
            +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm.--medium(
              :href="rules"
              target="_blank"
            ) {{ _("правилами пользования TOTIS Pharma") }}
        +b.g-cell.g-cols--12
          +b.ds-panel.--space_md
            +e.element.--offset_top
              +b.g-row--justify_center
                +b.g-cell.g-cols--12.--4-xl
                  +b.tt-button.BUTTON(
                    type='submit'
                    :disabled='isLoad',
                    @click.prevent='prepareData(valid)'
                  )
                    +e.title.P {{ _("Надiслати") }}
</template>

<script>
import {
  getSubjectsList,
  createFeedback,
} from '@api/feedback.service'
import pathOr from 'ramda/src/pathOr'
import { AnswerMessage } from '@utils/submit'
import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

export default {
  name: 'FeedbackForm',

  mixins: [FormMixin],

  data() {
    return {
      offer: window.offer,
      rules: window.rules,
      form: {
        name: window.request_name ? [window.request_lastname, window.request_name].filter(Boolean).join(' ') : '',
        subject: '',
        email: window.request_email,
        phone: window.request_phone,
        message: '',
        source: window.location.href,
      },
      subject: '',
      subjects: [],
    }
  },

  async created() {
    await this.getSubjects()
  },

  methods: {
    async getSubjects() {
      const { data: { items } } = (await getSubjectsList.execute())

      this.subjects = items
    },

    async prepareData(valid) {
      await this.$refs.validator.validate()

      if (!valid) return

      this.form.subject = pathOr('', ['id'], this.subject)

      this.submit(valid, this.form)
    },

    send(data) {
      return createFeedback.execute({}, data).then(res => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ event: 'form_submit_feedback' })

        AnswerMessage(res.data, this)

        this.$emit('close')

        this.$refs.validator.reset()
      })
    },

    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)

      this.$refs.validator.setErrors(parsed)
    },
  },
}
</script>
